import { render, staticRenderFns } from "./InvoiceUpload.vue?vue&type=template&id=130ad6e0&"
import script from "./InvoiceUpload.vue?vue&type=script&lang=js&"
export * from "./InvoiceUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports